import { common } from '@tencent/ceiba-base-components';
import Vue from 'vue';
import constant from './const';

let gShareConfig = {};
const isApp =  () => !!window.navigator.userAgent.match(/tgclub/i);
function getPlatform() {
  return window.Tgclub ? 'app' : '';
}

export default {
  /**
   * 初始化APP环境的分享功能
   */
  getPlatform,
  // initAPPShare: async (shareConfig) => {
  //   window.TGMobileShare = window?.TGMobileShare || (() => {});
  //   window.TGMobileShare({
  //     reportTcss: false,
  //     shareTitle: shareConfig?.title || '',
  //     shareDesc: shareConfig?.desc || '',
  //     shareImgUrl: shareConfig?.icon || 'https://ossweb-img.qq.com/images/tgclub/act/a20190221photo/Supercore-Icon-1.jpg',
  //     shareLink: shareConfig?.link || window.location.href,
  //     actName: `ceiba_${Vue.prototype.$actInfo.activity_id}`,
  //   });
  //   console.log('run initAPPShare params is   ', shareConfig);
  // },
  // isAPP: () => common.tool.getCookie('logintype') === 'supercore_m',
  // getPlatform: () => (common.tool.getCookie('logintype') === 'supercore_m' ? 'app' : ''),
  openView: (options) => {
    window.location.href = options.url;
  },
  getAstConfig: () => {
    const appid = common.tool.getQueryparams('appid')  || 'wxfb66a4e99e630765';
    return   { shareWxAppId: appid };
  },
  initAPPShare: async (shareConfig) => {
    console.log('app initAPPShare', shareConfig);
    gShareConfig = shareConfig;
    const initializeAppShare = () => {
      window.callShare = () => {
        window.Tgclub.shareWebPage(JSON.stringify({
          title: shareConfig?.title || '',
          summary: shareConfig?.desc || '',
          icon: constant.XY_APP_ICON,
          url: shareConfig?.link || window.location.href,
        }), () => {});
      };
      window.Tgclub.showFunctionButtonWithCallback(JSON.stringify({
        redpoint: 0,
        num: 0,
        iconurl: 'https://game.gtimg.cn/images/tgclub/act/model_test_pc/share_no_bg.png',
        callback: 'window.callShare()',
      }), () => {
        window.callShare();
      });
    };

    if (window.Tgclub) {
      initializeAppShare();
    } else {
      document.addEventListener('TgclubReady', () => {
        initializeAppShare();
      });
    }
  },
  setAPPShare: async (params) => {
    gShareConfig = params;
  },
  goAPPShare: async () => {
    if (isApp() && window.Tgclub) {
      const shareCallBack = typeof gShareConfig?.callback !== 'undefined' ? gShareConfig.callback : null;
      const xinyueAppShare  = {
        title: gShareConfig?.title,
        summary: gShareConfig?.desc,
        icon: constant.XY_APP_ICON,
        url: gShareConfig?.link || window.location.href,
      };
      // 心悦app ios 回调是一个函数 () =>{}
      // 心悦 安卓  回调是一个 函数字符串  "() =>{}"
      console.log('tgclub  goAPPShare xinyue  share config =', xinyueAppShare, ' shareCallBack =', shareCallBack);
      window.Tgclub.shareWebPage(JSON.stringify(xinyueAppShare), shareCallBack);
    }
  },
  disableAPPShare: async () => {
    console.log('tgclub disableAPPShare');
    if (common.platform.isIos) {
      // ios
      document.addEventListener(
        'TgclubReady',
        () => {
          window.Tgclub &&  window.Tgclub.hideFunctionButton();
        },
        false,
      );
    } else {
      if ('undefined' !== typeof window.Tgclub) {
        // 安卓
        window.Tgclub.hideFunctionButton();
      }
    }
  },
  isAPP: isApp,
  gotoAPP: async (link) => {
    console.log('tgclub gotoAPP');

    if (isApp()) {
      return false;
    }
    const url = link || window.location.href;
    const schemaUrl = `tgclub://redirect?url=${encodeURIComponent(url)}&share=0`;

    if (!isApp()) {
      if (!Vue.prototype.$platform.isIos && !Vue.prototype.$platform.isAndroid) {
        this.alert('仅适用IOS或Android');
        return;
      }
      if (Vue.prototype.$platform.isWX) {
        // 微信体系，使用wxJsBridge
        const timer = setTimeout(() => {
          clearTimeout(timer);
          window.WeixinJSBridge.invoke(
            'launchApplication',
            {
              schemeUrl: schemaUrl,
            },
            (res) => {
              // 微信内启动失败,跳转安装
              if (res.err_msg.indexOf('fail') !== -1) {
                if (Vue.prototype.$platform.isIos) {
                  // 微信ios
                  window.location.href = constant.IOS_DOWNLOAD_URL;
                } else if (Vue.prototype.$platform.isAndroid) {
                  // 微信安卓
                  window.location.href = constant.ANDROID_DOWNLOAD_URL;
                }
              }
            },
          );
        }, 500);
        return;
      }

      // IOS 手Q
      if (Vue.prototype.$platform.isIos && Vue.prototype.$platform.isQQ) {
        // ios的browser
        window.location.href = schemaUrl;
        setTimeout(() => {
          //  on.download && on.download();
          window.location.href = constant.IOS_DOWNLOAD_URL;
        }, 500);
      }

      // 剩下的情况 QQ 或者 安卓
      window.location.href = schemaUrl;
      // 延迟2.5秒跳转到安装地址
      const timer = setTimeout(() => {
        if (Vue.prototype.$platform.isIos) {
          window.location.href = constant.IOS_DOWNLOAD_URL;
        } else if (Vue.prototype.$platform.isAndroid) {
          window.location.href = constant.ANDROID_DOWNLOAD_URL;
        }
      }, 2500);
      // 判断是否隐藏页面,如隐藏则清除timer
      let visibilityChange = 'visibilitychange';
      if (typeof document.hidden !== 'undefined') {
        visibilityChange = 'visibilitychange';
      } else if (typeof document.mozHidden !== 'undefined') {
        visibilityChange = 'mozvisibilitychange';
      } else if (typeof document.msHidden !== 'undefined') {
        visibilityChange = 'msvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        visibilityChange = 'webkitvisibilitychange';
      }
      document.addEventListener(
        visibilityChange,
        (event) => {
          const isHidden = Vue.prototype.$platform.isIos ? event.hidden : document.hidden;
          if (isHidden) {
            clearTimeout(timer);
          }
        },
        false,
      );
    }
  },
};
